function SvgComponent() {
  return (
    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.9312 26.216C19.9177 26.216 25.5812 20.5524 25.5812 13.566C25.5812 6.57961 19.9177 0.916016 12.9312 0.916016C5.94485 0.916016 0.28125 6.57961 0.28125 13.566C0.28125 20.5524 5.94485 26.216 12.9312 26.216Z"
        fill="white"
      />
      <path
        d="M9.59301 18.3751C9.59301 18.3751 7.46234 19.1171 6.07934 18.3751C5.50207 18.1213 5.02795 17.6803 4.73266 17.1231C4.43738 16.566 4.33827 15.925 4.45239 15.3048C4.47131 14.6241 4.74298 13.9761 5.21411 13.4845C5.68524 12.9928 6.32197 12.6925 7.00122 12.6446C7.75922 12.1566 6.12262 7.8911 12.4426 8.0001C18.7626 8.1091 17.0637 12.4142 17.0637 12.4142C17.0637 12.4142 19.1578 11.973 19.8528 13.461C20.1238 14.035 20.6685 16.676 19.7375 17.711C18.7065 18.859 15.8665 18.3751 15.8665 18.3751"
        stroke="#040D13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9478 20.3184V11.7184L9.63281 14.0844"
        stroke="#040D13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9453 20.3184V11.7184L16.2623 14.0844"
        stroke="#040D13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgComponent;
